_           = require 'lodash'
_safeRemove = require('ub/utils').safeRemove

_filterForAdditionalPropErrors = (pageErrors) ->
  # code 303 == Unexpected Additional Properties
  propErrors = (err for err in pageErrors when err.code is 303)

  # code 10 == Does not match any schemas from 'anyOf'. These type of errors potentially have subErrors
  # that are additional properties errors
  subPropErrors = _(pageErrors)
    .filter (err) ->
      err.code is 10
    .map (err) ->
      err.subErrors
    .flatten()
    .filter (err) ->
      err.code is 303
    .value()

  propErrors.concat(subPropErrors)

module.exports = (pageData0, pomErrors, isDebugMode) ->
  nodesToRemoveWhitelist = [
    'geometry.aspectRatioa'
    'linkLightboxSize'
    'defaultBreakpointName'
    'style.newBackground.gradient.image'
    'children',
    'content.lightboxSize',
    'moveable',
    'resizeable',
    'removeable',
    'style.opacity',
    'content.confirmationPageSize.width',
    'content.confirmationPageSize.height'
  ]

  pageData = _.clone pageData0, true
  pages    = _.flatten [pageData.mainPage, pageData.subPages]

  for pageId, pageErrors of pomErrors
    currentPages = (page for page in pages when page.id is parseInt pageId, 10)

    additionalPropertiesErrors = _filterForAdditionalPropErrors(pageErrors.errors)

    for currentPage in currentPages
      for err in additionalPropertiesErrors
        # /23/geometry/aspectRatioa -> ['23', 'geometry', 'aspectRatioa']
        dataSplit        = err.dataPath[1..].split('/')
        elementIndex     = parseInt(dataSplit[0], 10)
        nodeToRemovePath = dataSplit.slice(1).join('.').trim()
        nodesToRemove =
          (whiteListedNode for whiteListedNode in nodesToRemoveWhitelist when whiteListedNode is nodeToRemovePath)

        for node in nodesToRemove
          element = currentPage.elements[elementIndex]

          if element
            _safeRemove element, nodeToRemovePath

            if isDebugMode
              console.log('REMOVED INVALID PROPERTY:', '"' + node + '"', 'for element:', element)

  return pageData



// WEBPACK FOOTER //
// ./src/data/pomValidationCleaner.coffee